export default "__VITE_ASSET__DtNPBX8g__"